import {
  Component,
  OnInit,
  Inject,
  AfterContentChecked,
  AfterViewInit,
} from "@angular/core";
import { HomeService } from "./home.service";
import { SharedService } from "./../../shared/shared.service";
import { ViewportScroller } from "@angular/common";
import { Router, NavigationEnd } from "@angular/router";
import { MetaService } from "src/app/shared/canonical.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent
  implements OnInit, AfterContentChecked, AfterViewInit {
  constructor(
    @Inject(HomeService) private homeService: HomeService,
    @Inject(SharedService) private SharedService: SharedService,
    private viewportScroller: ViewportScroller,
    private router: Router,
    private metaService: MetaService
  ) {
    router.events;
  }

  blogs: Array<any>;
  clients: Array<any>;
  portfolio: Array<any>;
  teams: Array<any>;
  testimonial: any;
  youtubeTestimonial: Array<any>;

  ngOnInit() {
    let href = this.router.url;
    this.metaService.createCanonicalURL(href);
    //  this.SharedService.showSpinner();
    // this.homeService.getContentData().subscribe((res: any) => {
    //   this.blogs = res.blogs;
    //   this.clients = res.clients;
    //   this.portfolio = res.portfolio;
    //   this.teams = res.teams;
    //   this.testimonial = {
    //     testimonial: res.testimonial,
    //     youtubeTestimonial: res.youtube_testimonial
    //   };
    //   this.homeService.sendBlogsData(this.blogs);
    //   this.homeService.sendClientsData(this.clients);
    //   this.homeService.sendPortfolioData(this.portfolio);
    //   this.homeService.sendTeamsData(this.teams);
    //   this.homeService.sendTestimonialData(this.testimonial);

    // });
    // $('#main_slider').carousel({
    //   interval: 8000,
    // });
  }

  ngAfterContentChecked() {
    //AOS.refresh();
  }
  ngAfterViewInit() {
    // this.SharedService.hideSpinner();
  }
}
